"use client";

import { ExpertSignIn } from "@/components/auth/expert-sign-in";

import { JoinPhoneStep, type SignupUtm } from "./join-phone-step";
import { JoinProfileStep } from "./join-profile-step";
import { JoinSourcesStep } from "./join-sources-step";

interface JoinFlowProps {
  step: "login" | "phone" | "sources" | "profile";
  returnUrl?: string;
  /**
   * Signup-time UTM attribution for the phone step's PostHog capture.
   * Resolved server-side in page.tsx so the client-side event includes
   * acquisition channel without an extra round-trip.
   */
  signupUtm?: SignupUtm | null;
}

export function JoinFlow({ step, returnUrl, signupUtm }: JoinFlowProps) {
  if (step === "phone") {
    return <JoinPhoneStep returnUrl={returnUrl} signupUtm={signupUtm} />;
  }

  if (step === "sources") {
    return <JoinSourcesStep returnUrl={returnUrl} />;
  }

  if (step === "profile") {
    return <JoinProfileStep returnUrl={returnUrl} />;
  }

  return <ExpertSignIn mode="join" returnUrl={returnUrl} />;
}
